module.exports = __webpack_public_path__ + "img/ic_publicity4.a5dacafd.jpeg";